import classNames from 'classnames/bind';

import React, { FC, HTMLAttributes } from 'react';

import styles from './Typography.module.scss';

const cx = classNames.bind(styles);

const H2: FC<HTMLAttributes<HTMLElement>> = ({ children, className, ...props }) => {
  const classes = cx('h2', className);

  return (
    <h2 className={classes} {...props}>
      {children}
    </h2>
  );
};

export default H2;
